/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 17:02:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-07-15 14:27:42
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/Detail/Summary/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { EDiscountType, EShipping } from '@/src/types/common/discount';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { ECondition as AnyORAnd } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/OrderEligibleCondition';
import {
  i18nGet,
  replaceI18nVariables,
  replaceI8nSequence,
  handleOnFormatCurrentSCTimeAndDate,
} from 'src/tools/tools';
import { EnumStatus } from 'src/types/common/discount';
import { DiscountValueType } from '../../../Components/AtDiscountValue';
import { ECondition } from '../../../Components/CustomerEligibleCondition';
import {
  EApplyTo,
  EType,
} from '../../../Components/OrderEligibleCondition/EligibleCard';
import { useSalesChannelIsMiniProgram } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { EProductType } from '../../../Components/ProductsApplyToRadioAndTable';
import SummaryComponent from '../../../Components/Summary';
import { CumulativeType } from '../Buy1Get1Free';
import { EDestinationType } from '../Destination';
import css from './css.module.less';
interface IProps {
  status?: string;
  activeTime?: any;
}
const Summary = ({ status, activeTime }: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    beginDate = '',
    beginTime = '',
    endDate = '',
    endTime = '',
  } = activeTime;

  const isMini = useSalesChannelIsMiniProgram();

  const renderSummaryData = (getFieldsValue) => {
    const begin = beginDate
      ? handleOnFormatCurrentSCTimeAndDate(beginDate + ' ' + beginTime)
      : '';
    const end = endDate
      ? handleOnFormatCurrentSCTimeAndDate(endDate + ' ' + endTime)
      : '';
    const {
      codes,
      autoCombineDisabled,
      codeCombineDisabled,
      discountMethod = {},
      applyTo = {},
      customerCondition = {},
      userLimitation = {},
      conditions = {},
      currencyCode,
    } = getFieldsValue([
      'codes',
      'autoCombineDisabled',
      'codeCombineDisabled',
      'discountMethod',
      'applyTo',
      'customerCondition',
      'userLimitation',
      'conditions',
      'currencyCode',
    ]);
    const {
      getsQty,
      discountItemScope,
      maxSelection,
      discountValue,
      percentage,
      reductionAmount,
      discountType,
      deduction,
      buysQty,
      shippingDiscountType,
      maxDeductionEnabled,
      maxDeduction,
      destinationType,
      fixedAmount,
      cumulative: cumulativeDiscountMethod = false,
      cumulativeType: cumulativeTypeDiscountMethod = false,
    } = discountMethod;
    const { conditions: conditionsAll = [], condRelation } = conditions;
    const {
      flashSaleExcluded = '',
      conditionType = '',
      maxTimes = '',
      maxTimesEnabled = false,
      toEntireOrder = false,
      cumulative = false,
    } = applyTo || {};
    const { conditionType: customerConditionType } = customerCondition;
    const {
      maxInTotal = '',
      maxInTotalEnabled,
      maxPerCustomer = '',
      maxPerCustomerEnabled,
    } = userLimitation;

    const autoCombine =
      autoCombineDisabled || codeCombineDisabled
        ? autoCombineDisabled && codeCombineDisabled
          ? getI18n(
              'salesChannelDirectDiscount.summary.cannotcombinewithotherdiscounts',
            )
          : autoCombineDisabled
          ? getI18n(
              'salesChannelDirectDiscount.summary.cannotcombinewithotherautomaticdiscounts',
            )
          : getI18n(
              'salesChannelDirectDiscount.summary.cannotcombinewithotherpromocodediscounts',
            )
        : '';

    const discountValueApplies = {
      [EProductType.All]: getI18n('general.allProducts'),
      [EProductType.Specific]: getI18n(
        'salesChannelDirectDiscount.eligibalCondition.specificProducts',
      ),
      [EProductType.NotSpecific]: getI18n(
        'salesChannelDirectDiscount.summary.noSpecific',
      ),
    };

    const conditionsApplyToText = {
      [EApplyTo.All]: getI18n(
        'salesChannelDirectDiscount.discountValuebuyOne.allProducts',
      ),
      [EApplyTo.Collections]: getI18n(
        'salesChannelDirectDiscount.discountValuebuyOne.specificCollections',
      ),
      [EApplyTo.Products]: getI18n(
        'salesChannelDirectDiscount.eligibalCondition.specificProducts',
      ),
    };

    const discountValueText = {
      [DiscountValueType.Free]: ` ${getI18n('general.free')}`,
      [DiscountValueType.Reduction]: ` $${reductionAmount} ${getI18n(
        'salesChannelDirectDiscount.summary.reduction',
      )}`,
      [DiscountValueType.Percentage]: ` ${percentage}% ${getI18n(
        'salesChannelDirectDiscount.summary.reduction',
      )}`,
    };

    const discountMethodText = {
      [EDiscountType.Percentage]: `${percentage || '0'}% ${getI18n(
        'salesChannelDirectDiscount.summary.offappliesto',
      )}  ${discountValueApplies[conditionType] || ''} ${
        flashSaleExcluded
          ? getI18n(
              'salesChannelDirectDiscount.summary.excludingflashsaleitems',
            )
          : ''
      }`,
      [EDiscountType.Reduction]: `$${deduction || '0'}  ${getI18n(
        'salesChannelDirectDiscount.summary.reductionamountappliesto',
      )} ${
        toEntireOrder
          ? getI18n('salesChannelDirectDiscount.summary.theentireorder')
          : getI18n('salesChannelDirectDiscount.summary.allproducts')
      } ${
        flashSaleExcluded
          ? getI18n(
              'salesChannelDirectDiscount.summary.excludingflashsaleitems',
            )
          : ''
      }`,
      [EDiscountType.Shipping]: `${
        shippingDiscountType == EShipping.Free
          ? `${getI18n('salesChannelDirectDiscount.summary.freeshippingto')} `
          : '$' +
            fixedAmount +
            ` ${getI18n(
              'salesChannelDirectDiscount.summary.reductiononshippingrateto',
            )}`
      } ${
        destinationType == EDestinationType.All
          ? ` ${getI18n(
              'salesChannelDirectDiscount.discountValueship.allcountry/region',
            )}`
          : ` ${getI18n(
              'salesChannelDirectDiscount.discountValueship.specificcountry/region',
            )}`
      } ${
        maxDeductionEnabled && maxDeduction
          ? replaceI18nVariables(
              getI18n(
                'salesChannelDirectDiscount.summary.excludingshippingrageover',
              ),
              maxDeduction,
            )
          : ''
      }`,
      [EDiscountType.Gift]: `${replaceI18nVariables(
        getI18n('salesChannelDirectDiscount.summary.buyget'),
        buysQty || 0,
        getsQty || 0,
      )} ${discountValueText[discountValue] || ''} ${getI18n(
        'salesChannelDirectDiscount.summary.for',
      )} ${conditionsApplyToText[discountItemScope] || ''}${
        flashSaleExcluded
          ? getI18n(
              'salesChannelDirectDiscount.summary.excludingflashsaleitems',
            )
          : ''
      }`,
    };

    const customerConditionText = {
      [ECondition.Everyone]: getI18n(
        'salesChannelDirectDiscount.summary.foreveryone',
      ),
      [ECondition.Registered]: getI18n(
        'salesChannelDirectDiscount.summary.forregisteredcustomers',
      ),
      [ECondition.Specific]: getI18n(
        'salesChannelDirectDiscount.summary.forspecificcustomers',
      ),
    };
    const multiConditions =
      condRelation === AnyORAnd.Or
        ? `${getI18n('salesChannelDirectDiscount.summary.anyCondition')}: `
        : `${getI18n('salesChannelDirectDiscount.summary.allCondition')}: `;

    const conditionsAllText = (conditionsAll || [])
      .map((item) => {
        if (!item.minimum) {
          return '';
        }

        const isCount = item.basedOn !== EType.Value;
        const isLargeThan = item.minimum && !item.maximum;
        const text1 = isCount
          ? getI18n('salesChannelGiftPurchase.summary.quantityof')
          : getI18n('salesChannelGiftPurchase.summary.amountof');

        const text2 =
          item.applyTo === EApplyTo.All
            ? conditionsApplyToText[EApplyTo.All]
            : conditionsApplyToText[item.applyTo];

        const unit = isCount ? '' : '$';
        const minimum = `${unit}${item.minimum}`;
        const maximum = `${unit}${item.maximum}`;

        const text5 = item.flashSaleExcluded
          ? getI18n(
              'salesChannelDirectDiscount.summary.excludingflashsaleitems',
            )
          : '';
        const text0 = replaceI8nSequence(
          getI18n(
            isLargeThan
              ? 'salesChannelGiftPurchase.summary.conditionsTextLargeThan'
              : 'salesChannelGiftPurchase.summary.conditionsTextFromTo',
          ),
          text1,
          text2,
          minimum,
          maximum,
        );

        return `${text0} ${text5}`;
      })
      .filter((o) => o !== '');
    const summaryData = [
      ...(currencyCode && !isMini
        ? [`${getI18n('general.applicableCurrency')} ${currencyCode}`]
        : []),
      ...(begin
        ? [
            `${replaceI18nVariables(
              getI18n('salesChannelDirectDiscount.summary.validfrom'),
              begin,
            )} ${
              end
                ? ` ${getI18n('general.to')} ${end}`
                : ` , ${getI18n(
                    'salesChannelDirectDiscount.summary.noenddate',
                  )}`
            }`,
          ]
        : []),
      ...(codes && codes.length
        ? [
            `${codes.length} ${getI18n('general.promocodes')}`,
            ...(autoCombine ? [autoCombine] : []),
          ]
        : []),
      ...(discountType ? [discountMethodText[discountType]] : []),

      ...(cumulativeTypeDiscountMethod && cumulativeDiscountMethod
        ? [
            `${getI18n('salesChannelDirectDiscount.summary.elConditionMet')} ${
              cumulativeTypeDiscountMethod == CumulativeType.ConditionCumulative
                ? getI18n(
                    'salesChannelDirectDiscount.discountValuereduction.cumulatively',
                  )
                : ''
            }`,
          ]
        : []),
      ...(maxSelection
        ? [
            `${replaceI18nVariables(
              getI18n('salesChannelDirectDiscount.summary.limitUse'),
              maxSelection,
            )}`,
          ]
        : []),
      ...(cumulative
        ? [`${getI18n('salesChannelDirectDiscount.summary.elWheneverMet')}.`]
        : []),
      ...(maxTimes &&
      maxTimesEnabled &&
      discountType === EDiscountType.Percentage
        ? [
            `${replaceI18nVariables(
              getI18n('salesChannelDirectDiscount.summary.maxTime'),
              maxTimes,
            )}`,
          ]
        : []),
      ...(customerConditionType
        ? [customerConditionText[customerConditionType]]
        : []),

      ...(maxInTotalEnabled || maxPerCustomerEnabled
        ? [
            maxInTotalEnabled && maxPerCustomerEnabled
              ? replaceI18nVariables(
                  getI18n('salesChannelDirectDiscount.summary.limit1'),
                  maxInTotal,
                  maxPerCustomer,
                )
              : !maxInTotalEnabled && maxPerCustomerEnabled
              ? `${replaceI18nVariables(
                  getI18n('salesChannelDirectDiscount.summary.limit2'),
                  maxPerCustomer,
                )}`
              : `${replaceI18nVariables(
                  getI18n('salesChannelDirectDiscount.summary.limit3'),
                  maxInTotal,
                )}`,
          ]
        : []),
      ...((conditionsAll || []).length >= 2 ? [multiConditions] : []),
      ...((conditionsAll || []).length ? conditionsAllText : []),
    ];
    return summaryData;
  };

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.sectionContainer}
        title={getI18n('general.summary')}>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue, getFieldsValue }) => {
            return (
              <SummaryComponent
                name={getFieldValue('name')}
                status={status || EnumStatus.Draft}
                summaryContent={renderSummaryData(getFieldsValue)}
              />
            );
          }}
        </Form.Item>
      </SectionWrapper>
    </div>
  );
};

export default Summary;
